enum BROWSER_MIN_VERSION {
    chrome = "87.0.4280",
    ios = "13.0.1",
    nonNativeBrowseriOS = "14.3.0",
    samsung = "12.0.0",
};
export default BROWSER_MIN_VERSION